<template>
  <div class="focused-panel">
    <div class="d-flex wellpad-toolbar">

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select well drainage area" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Move well drainage area" :disabled="!wellFeatureSelected"
             :pressed.sync="translateEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
        <icon scale=".6" name="pencil-alt" />
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>
    <b-modal v-model="showForm" size="lg" no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header">
        <label>{{formTitle}}</label>
        <!-- <div v-if='editablePhase'>
          <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
          </div>

          <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
            <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
            <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
          </div>
        </div> -->
      </div>

      <div class="p-2">
        <div id='feature-locked-warning' v-if="!editablePhase">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. It cannot be edited in this Area of responsibility</b-alert>
        </div>
        <!-- <div id='feature-locked-warning' v-if="editablePhase && featureLock">
          <b-alert class='user-reminder' variant="warning" show>This feature is locked. Click the unlock button in the upper right to edit feature</b-alert>
        </div> -->
        <b-form>
          <b-row>
            <b-col>
              <b-form-group label="Drainage Buffer Radius:" label-for="radius-select">
                <b-form-select :options="radiusOptions" id="radius-select" :disabled="featureLock" v-model="wellAttrs['overrides']" placeholder="Please, select option"></b-form-select>
              </b-form-group>
              <b-form-group label="Comment:" label-for="drainageComment">
                <b-textarea id="drainageComment" :disabled="featureLock" v-model="wellAttrs['comment']" rows="3"></b-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <div role="group" class="btn-group">
          <b-btn size="sm" class="float-right" variant="primary" @click="close">
            Close
          </b-btn>
          <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
            Save
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import 'vue-awesome/icons/circle-notch'

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import RotateFeatureInteraction from 'ol-rotate-feature'
  import TranslateInteraction from 'ol/interaction/Translate'

  export default {
    name: 'well-drainage-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    created () {
      this.translateInteraction = null
    },
    data () {
      return {
        geomType: 'Polygon',
        wellLayerName: 'v4:_well_drainage',
        identName: 'id',
        wellAttrs: {
          ident: '',
          comment: ''
        },
        hoverLock: false,
        lockable: true,
        schema: 'well_drainage',
        radiusOptions: [
          '400',
          '500',
          '600',
          '750',
          'No Override'
        ],
        radiusDefault: '500',
      }
    },
    methods: {
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      }
    },
    watch: {
      translateEnabled (val) {

        if (val) {
          if (this.translateInteraction) {
            this.$mapService.map.removeInteraction(this.translateInteraction)
            this.translateInteraction = null
          }
          this.translateInteraction = new TranslateInteraction({
            features: this.selectInteraction.getFeatures()
          })

          this.$mapService.map.addInteraction(this.translateInteraction)
          this.translateInteraction.on('translateend', this.editGeom, this)
          this.translateInteraction.on('translatestart', this.beforeEditGeom, this)
        } else {
          this.$mapService.map.removeInteraction(this.translateInteraction)
          this.translateInteraction.un('translateend', this.editGeom, this)
          this.translateInteraction.on('translatestart', this.beforeEditGeom, this)
          this.translateInteraction = null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/WellDrainageEditor.vue